export function TelegramIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M21 4L3 11.53L9.75 13.88L18 7.5L12 14.25V20L15.38 16.69L20.47 20L21 4Z"
        fill="currentColor"
      />
    </svg>
  );
}
